import { AbstractControl } from "@angular/forms";

export class CepValidator {
  static validateCep(control: AbstractControl) {
    const value = control.value as string;
    if (!value) {
      return null;
    }

    return /^[0-9]{8}$/.test(value.replace(/\D/g, "")) ? null : { cepInvalid: true };
  }
}
